import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getSelectCustomerKonten = async (clientId) => {
    try {
        const response = await axios.get(`/admin/konten/getKonten/${clientId}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addSelectCustomerKonten = async (payload, clientId) => {
    try {
        const response = await axios.post(`/admin/konten/createKonten/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateSelectCustomerKonten = async (payload, clientId) => {
    try {
        const response = await axios.put(`/admin/konten/updateKonten/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteSelectCustomerKonten = async (payload, clientId) => {
    try {
        const response = await axios.put(`/admin/konten/deleteKonten/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const getSelectCustomerDarlehen = async (clientId) => {
    try {
        const response = await axios.get(`/admin/konten/getDarlehen/${clientId}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const addSelectCustomerDarlehen = async (payload, clientId) => {
    try {
        const response = await axios.post(`/admin/konten/createDarlehen/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const updateSelectCustomerDarlehen = async (payload, clientId) => {
    try {
        const response = await axios.put(`/admin/konten/updateDarlehen/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteSelectCustomerDarlehen = async (payload, clientId) => {
    try {
        const response = await axios.put(`/admin/konten/deleteDarlehen/${clientId}`, payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}
